import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getUser from "../services/decodeJWT";
import { useState } from "react";
import { useEffect } from "react";
import ApiService from "../services/ApiService";
import UserService from "../hooks/UserService";

const Nav = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = getUser();
  const [profileData, setProfileData] = useState({});

  const isAdmin = !!(UserService?.data()?.role == 'admin' || UserService?.data()?.role == 'superAdmin');

  const fetchProfile = async () => {
    try {
      const response = await ApiService.get(`/cms/profiles?author=${currentUser?._id}&name=${currentUser?.username}`);
      if (response?.contents) {
        setProfileData(response?.contents[0]?.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [])


  const menuItemsLeft = [
    {
      href: "/chat",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat-text-fill" viewBox="0 0 16 16">
          <path d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z" />
        </svg>
      ),
      label: "Chats",
      protected: false,
    },
    {
      href: "/clone-list",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
          <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
        </svg>
      ),
      label: "Clone List",
      protected: false,
    },
    {
      href: "/dashboard/total-earnings",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-grid-1x2-fill" viewBox="0 0 16 16">
          <path d="M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1z" />
        </svg>
      ),
      label: "Dashboard",
      protected: true,
    },
    {
      href: "/pricing",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags-fill" viewBox="0 0 16 16">
          <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
          <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043z" />
        </svg>
      ),
      label: "Pricing",
      protected: false,
    },
  ]?.filter(item => {

    if (item?.protected) {

      if (isAdmin) {
        return item
      } else {
        return false
      }

    } else {
      return item
    }

  });

  const handleLogout = () => {
    toast.success("You've just logged out.", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

    localStorage.removeItem("token");

    setTimeout(() => navigate("/login"), 2100);
  };

  return (
    <nav className="tyn-appbar">
      <div className="tyn-appbar-wrap">
        <div className="tyn-appbar-logo">
          <Link className="tyn-logo" to="/">
            <img src="/images/logo/bardo_icon.svg" alt="Logo" />
          </Link>
        </div>
        <div className="tyn-appbar-content">

          <ul className="tyn-appbar-nav tyn-appbar-nav-start">
            {menuItemsLeft.map((item, index) => {
              const isActive = location.pathname === item.href ||
                (item.href.startsWith("/dashboard") && location.pathname.startsWith("/dashboard")) ||
                (location.pathname.startsWith(item.href + '/'));
              return (
                <li className="tyn-appbar-item position-relative" key={index}>
                  <Link className={`tyn-appbar-link ${isActive ? 'active' : ''}`} to={item?.href}>
                    {item.icon}
                    {item.badge && (
                      <span className="badge bg-secondary position-absolute rounded-pill top-0 end-0 mt-n1 me-n1">
                        {item.badge}
                      </span>
                    )}
                    <span className="d-none">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* RIGHT NAVBAR MENU */}
          <ul className="tyn-appbar-nav tyn-appbar-nav-end">
            <li className="tyn-appbar-item user-icon">
              <Link className="d-inline-flex dropdown-toggle" data-bs-toggle="dropdown" to={'/'} data-bs-offset="0,10">
                <div className="tyn-media tyn-size-lg tyn-circle">
                  <img src={profileData?.picture?.media || '/images/avatar/avatar-default.jpg'} alt="User Avatar" />
                </div>
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <div className="dropdown-gap">
                  <div className="tyn-media-group">
                    <div className="tyn-media tyn-size-lg">
                      <img src={profileData?.picture?.media || '/images/avatar/avatar-default.jpg'} alt="User Avatar" />
                    </div>
                    <div className="tyn-media-col">
                      <div className="tyn-media-row">
                        <h6 className="name">Hello,
                          {(currentUser?.username && currentUser?.username.includes('@'))
                            ? currentUser?.username.split('@')[0].charAt(0).toUpperCase() + currentUser?.username.split('@')[0].slice(1)
                            : (currentUser?.username || "Your Name").charAt(0).toUpperCase() + (currentUser?.username || "Your Name").slice(1)
                          }!
                        </h6>
                      </div>
                      <div className="tyn-media-row has-dot-sap">
                        <p className="content">{currentUser?.role ? currentUser?.role.toUpperCase() : "Role"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tyn-list-links">
                  <li>
                    <span style={{ fontSize: '0.75rem' }} className="fw-bold ps-3">
                      {currentUser?.username ? currentUser?.username : "youremail@exmple.com"}
                    </span>
                    <Link to="/profile">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                      <span>Profile</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/"} onClick={handleLogout}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-power"
                        viewBox="0 0 16 16"
                      >
                        <path d="M7.5 1v7h1V1z" />
                        <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
                      </svg>
                      <span>Log Out</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
